"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var GroupHeader_styles_1 = require("./GroupHeader.styles");
var GroupHeader_base_1 = require("./GroupHeader.base");
exports.GroupHeader = Utilities_1.styled(GroupHeader_base_1.GroupHeaderBase, GroupHeader_styles_1.getStyles, undefined, {
    scope: 'GroupHeader'
});
//# sourceMappingURL=GroupHeader.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/GroupedList/GroupHeader.js
// module id = 881
// module chunks = 0